// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '에이프로젠제약',
  targetSheetName: '202606',
  headerRowIndex: 1,
  headerRowCount: 1,
  dataStartRowIndex: 2,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    commissionRate: 'DC',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '보험코드',
    '분류',
    '제품명',
    '성분명',
    '대조약',
    '변경기준가',
    '기준가',
    '차액',
    'DC',
    '생동구분',
    '비고',
  ],
});
